import React, { useState, useMemo } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import { Button, ButtonVariantOption } from "@/components/Button";
import { SizingWrapperStyle } from "@/components/Wrapper";
import type { SelectChangeEvent } from "@mui/material";
import { DesignPreviewModal } from "@/features/dmManagement/components/DesignPreviewModal";
import type { Design } from "@/features/dmManagement/types";

interface DesignSelectorProps {
  designs: Design[];
  selectedDesignId?: number;
  onDesignChange: (designId: number) => void;
}

/**
 * デザイン選択セレクトボックス
 * 承認済みデザインの中から注文に使用するデザインを選択し、プレビューを確認できる
 */
export const DesignSelector: React.FC<DesignSelectorProps> = ({
  designs,
  selectedDesignId,
  onDesignChange,
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);

  const approvedDesigns = useMemo(
    () => designs.filter((d) => d.status === "approved"),
    [designs]
  );

  const selectedDesign = approvedDesigns.find((d) => d.id === selectedDesignId);

  const handleChange = (event: SelectChangeEvent): void => {
    onDesignChange(Number(event.target.value));
  };

  return (
    <Box>
      <Stack direction="row" spacing={2} alignItems="center">
        <FormControl size="small" sx={{ minWidth: 300 }}>
          <InputLabel id="design-selector-label">デザイン</InputLabel>
          <Select
            labelId="design-selector-label"
            value={selectedDesignId != null ? String(selectedDesignId) : ""}
            label="デザイン"
            onChange={handleChange}
          >
            {approvedDesigns.map((design) => (
              <MenuItem key={design.id} value={design.id}>
                {design.taskName}（{design.productName}）
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          label="プレビュー"
          variant={ButtonVariantOption.Outlined}
          disabled={!selectedDesign}
          onClick={() => {
            setPreviewOpen(true);
          }}
          size={SizingWrapperStyle.INHERIT}
        />
      </Stack>
      {selectedDesign && (
        <DesignPreviewModal
          open={previewOpen}
          onClose={() => {
            setPreviewOpen(false);
          }}
          components={selectedDesign.components}
        />
      )}
    </Box>
  );
};
